import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import './CookieConsent.css';

const CookieConsent = () => {
  const [showBanner, setShowBanner] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      setShowBanner(true);
    }
  }, []);

  const acceptCookies = () => {
    localStorage.setItem('cookieConsent', 'accepted');
    setShowBanner(false);
  };

  const declineCookies = () => {
    localStorage.setItem('cookieConsent', 'declined');
    setShowBanner(false);
  };

  if (!showBanner) return null;

  return (
    <div className="cookie-consent">
      <div className="cookie-consent-content">
        <div className="cookie-consent-text">
          <h4>Cookie Consent</h4>
          <p>
            We use cookies to enhance your browsing experience, analyze site traffic, and personalize content. 
            By clicking "Accept All", you consent to our use of cookies. You can learn more in our{' '}
            <Link to="/privacy-policy">Privacy Policy</Link>.
          </p>
        </div>
        <div className="cookie-consent-buttons">
          <button onClick={declineCookies} className="btn-cookie decline">
            Decline
          </button>
          <button onClick={acceptCookies} className="btn-cookie accept">
            Accept All
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;

